import { CloudinaryUploadButton } from '@/components/upload';
import { useToast } from '@chakra-ui/react';
import type { CloudinaryUploadResult } from '@/hooks/useCloudinaryUpload';

interface ProfilePictureUploadProps {
  currentImageUrl?: string;
  onImageUpload: (url: string) => void;
}

/**
 * Cover photo upload component for lists (despite the generic name — every
 * current call site is a List Cover Photo flow: `ListDetails.tsx`,
 * `CollaborativeListSettingsModal.tsx`, `ListFormFields.tsx`). Uses the
 * centralized CloudinaryUploadButton with square cropping.
 */
export function ProfilePictureUpload({
  currentImageUrl,
  onImageUpload,
}: ProfilePictureUploadProps) {
  const toast = useToast();

  const handleRemove = () => {
    onImageUpload('');
    toast({
      title: 'Profile picture removed',
      status: 'success',
      duration: 2000,
      isClosable: true
    });
  };

  const handleUpload = (result: CloudinaryUploadResult) => {
    onImageUpload(result.url);
  };

  return (
    <CloudinaryUploadButton
      currentUrl={currentImageUrl}
      onUpload={handleUpload}
      onRemove={handleRemove}
      mode="widget"
      cropping={true}
      aspectRatio={1}
      notifyOnEmptyClose={true}
      size="md"
      shape="rounded"
      showRemoveButton={true}
      uploadLabel="Upload Picture"
      changeLabel="Change Picture"
      helpText="JPG, PNG, or WEBP • Max 100MB"
    />
  );
}
